import { useEffect, useState } from 'react';
import Select from 'react-select';
import { BaseSelector } from '../../../domain/shared';
import { rolesRepository } from '../../../infrastructure/repositories/roles/roleRepository';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: number | string | undefined;
    disabled: boolean;
    name: string;
}

export default function RoleSelector({
    onChange,
    value,
    name,
    disabled = false,
}: Props) {
    const [roles, setRoles] = useState<BaseSelector[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        rolesRepository.GetRolesList().then((res) => {
            setIsLoading(false);
            setRoles(
                res.map((dt) => ({
                    label: dt.name,
                    value: dt.id,
                }))
            );
        });
    }, []);

    return (
        <div className='mb-2'>
            <label htmlFor='ubications' className='form-label form-label'>
                Seleccione un Rol 
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isLoading={isLoading}
                isSearchable
                isDisabled={disabled}
                name='color'
                options={roles}
                onChange={(e) => {
                    onChange(name, e?.value);
                }}
                value={
                    roles.find((a) => a.value === value) ?? {
                        label: `Seleccione`,
                        value: 0,
                    }
                }
            />
        </div>
    );
}
